// extracted by mini-css-extract-plugin
export default {"discountLine":"Discount-module--discount-line--4a1da","discountTitle":"Discount-module--discount-title--ab17d"};